<div class="marg">
    <div class="login">
        <div class="row">
            <div class="col-md-7 col-sm-6">
                <img src="assets/icons/meLogo.svg" alt="login" class="kellton-img">
                <div class="txt">Our mission is to make the home a better place to be.</div>
            </div>
            <div class="col-md-5 col-sm-6">
                <router-outlet></router-outlet>
            </div>
        </div>

    </div>
    <div class="ttt">Setu Kohli Home © 2025. All Rights Reserved</div>
</div>